import ReactDOM from "react-dom";
import Header from "../../../Global/Header/Header";
import { useEffect, useRef, useState } from "react";
import classes from "../Tabs/Itinerary/Itinerary.module.css";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../../components/ui/avatar";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../components/ui/accordion";
import SpotFormMobile from "../SpotForm/SpotFormMobile";
import { Toaster } from "../../../components/ui/toaster";
import { Button } from "../../../components/ui/button";
import RefundPolicy from "../Tabs/RefundPolicy/RefundPolicy";
import TripStays from "./TripStays/TripStays";
import SvgHtmlPassing from "../../../components/functions/SvgHtmlPassing";

export const SingleTripViewMobile = ({
  showLoader,
  tripName,
  tripTitle,
  tripDetailBgImg,
  mobileTripDetailBgImg,
  curatorViewModel,
  spotFormViewModel,
  quickDetailsViewModel,
  itineraryViewModel,
  tripOverview,
  tripStays,
  vibeGallery,
  location,
  uniqueness,
  onFormSubmitted,
  initiatePayment,
}) => {
  const formRef = useRef(null);
  const [influencerPopup, setInfluencerPopup] = useState(false);
  const [currentMobileTripBgImgIndex, setCurrentMobileTripBgImgIndex] = useState(0);

  const onBookNowClicked = () => {
    formRef.current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if(mobileTripDetailBgImg.length>1){
      const interval = setInterval(() => {
        setCurrentMobileTripBgImgIndex((prevIndex) => {
          return (prevIndex + 1) % mobileTripDetailBgImg.length;
        });
      }, 3000);
      return () => clearInterval(interval);
    }
  },[mobileTripDetailBgImg]);

  if (showLoader) {
    return (
      <>
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100 dark:bg-gray-900">
          <div
            className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status"
          ></div>
          <p className="mt-4 text-lg font-semibold text-gray-700 dark:text-gray-300">
            Loading ...
          </p>
        </div>
      </>
    );
  }

  const accordionItems = [
    "item-1",
  ];

  return (
    <>
      <div>
        <InfluencerPopup influencerPopup={influencerPopup} setInfluencerPopup={setInfluencerPopup} curatorViewModel={curatorViewModel} />
        <div className="relative">
          <div className="absolute inset-0 flex flex-col justify-between p-4 bg-gradient-to-t from-black to-transparent" />
          <div className="absolute top-0 left-0 right-0">
            <Header activeTab={""} activeColor={"#000000"} />
          </div>
          <img
            alt="Trip Pic"
            className="h-[85vw] w-full object-cover"
            src={mobileTripDetailBgImg[currentMobileTripBgImgIndex]}
            style={{
              aspectRatio: "768/200",
              objectFit: "cover",
            }}
            width="768"
          />
          <div className="absolute inset-x-0 bottom-0 px-4 pb-4">
            <h2 id="tripName" className="text-3xl font-bold text-white">{tripName}</h2>
          </div>
        </div>
        <div className="py-4">
          <div className="px-4 mb-4">
            <p className="text-lg text-orange-600 font-bold">{tripTitle}</p>
          </div>
          <div className="w-full flex flex-row items-center px-4 mb-4"
            onClick={() => { setInfluencerPopup(true) }}
          >
            <Avatar>
              <AvatarImage
                alt={curatorViewModel.curatorName}
                src={curatorViewModel.curatorImg}
              />
              <AvatarFallback>H</AvatarFallback>
            </Avatar>
            <div className="ml-2">
              <h4 className="text-lg font-semibold">Meet your Host</h4>
              <p className="text-sm">{curatorViewModel.curatorName}</p>
            </div>
            <div className="ml-auto">
              <InstagramIcon className="w-[40px] h-[40px] stroke-[1.3] text-red-600"
                onClick={(e) => {
                  e.stopPropagation();
                  const link = curatorViewModel.curatorInstaId ? `https://www.instagram.com/${curatorViewModel.curatorInstaId}` : "https://www.instagram.com/exploro.club";
                  window.open(link, "_blank", "noopener,noreferrer")
                }}
              />

            </div>
          </div>
          {
            tripOverview.length > 0 &&
            <div className="grid grid-cols-2 mt-[3vh]">
              {
                tripOverview.map((item, index) => (
                  <div className="flex flex-row space-x-[2vw] pl-[4vw] min-h-[80px]">
                    {
                      <SvgHtmlPassing content={item.svgIcon} className="w-[6vw] h-[6vw]" />
                    }
                    <div className="flex flex-col">
                      <p className="text-lg">{item.svgHeading}</p>
                      <p className="text-sm font-bold">{item.svgDesc}</p>
                    </div>
                  </div>
                ))
              }
            </div>}

          {location && <div className="w-full min-h-[40px] flex flex-row pl-[3vw] space-x-[2vw] items-center border-t-[1px] border-[rgba(0,0,0,0.2)] text-[3.5vw] mb-[10vw]">
            <LocationIcon />
            <p>{location}</p>
          </div>}
          <div>
            <p className="ml-[7vw] text-[6vw] font-[500] mb-[5vw]">Quick Plan</p>
            {
              itineraryViewModel.itineraryList.map((it, index) => {
                return (
                  <div style={{ border: `${index + 1 == itineraryViewModel.itineraryList.length ? "none" : ""}` }} className="w-[87%] flex flex-row min-h-[70px] space-x-[6vw] border-l-[2px] border-[rgba(0,0,0,0.3)] border-dotted ml-[11vw]">
                    {/* <div className="w-[15px] h-[70px] flex flex-col items-center"> */}
                    <div style={{ marginLeft: `${index + 1 == itineraryViewModel.itineraryList.length ? "-1.7vw" : ""}` }} className="w-[4vw] h-[4vw] ml-[-2.2vw] bg-white rounded-full border-[1.3px] border-black absolute">
                    </div>
                    {/* <div style={{border:`${index+1==itineraryViewModel.itineraryList.length?"none":""}`}} className="h-[55px] w-[0.11px] border-l-[2px] border-dotted border-[rgba(0,0,0,0.3)]">
                        </div>
                    </div> */}
                    <div className="flex flex-col mb-[3vh] mt-[-1.6vw]">
                      <p className="text-[5vw] font-[500]">Day {index + 1}</p>
                      <p className="mt-[1vw] mb-[2vw] text-[4vw]">{it.heading.split('|')[1] || it.heading.split(':')[1]}</p>
                    </div>
                  </div>
                )
              })
            }
          </div>
          {
            uniqueness.length > 0 &&
            <div>
              <p className="ml-[7vw] text-[6vw] font-[500] mb-[3vw]">The Uniqueness</p>
              {
                uniqueness.map((unique, index) => {
                  return (
                    <div className="w-full h-[15vw] flex flex-row items-center ml-[7vw] space-x-4">
                      <span className="min-w-[6vw] min-h-[6vw] p-0">{
                      <SvgHtmlPassing content={unique.svgIcon} className="w-[6vw] h-[6vw]" />
                    }</span>
                      <p className="text-[4vw]">{unique.heading}</p>
                    </div>
                  )
                })
              }
            </div>}
          <div className="space-y-2">
            <Accordion
              type="multiple"
              collapsible
              className="w-full"
              defaultValue={accordionItems}
            >
              <AccordionItem
                value="item-1"
                className="text-black bg-gray-50 px-4"
              >
                <AccordionTrigger>
                  <div className="text-black py-2 px-4 text-start w-full">
                    ITINERARY
                  </div>
                </AccordionTrigger>
                <AccordionContent>
                  <div className="bg-white py-4">
                    {itineraryViewModel.itineraryList.map((it, index) => {
                      return (
                        <div
                          key={index}
                          className={classes["mobile-day-container"]}
                        >
                          <div className={`${classes["day-text-container"]} mb-2`}>
                            <p className={classes["day-text-heading"]}>
                              {it.heading}
                            </p>
                            <img
                              className={"w-full h-[50vw] object-cover rounded-[10px] my-3"}
                              src={it.img}
                              alt=""
                            />
                            <ol
                              style={{
                                listStyleType: "disc",
                                paddingLeft: "3vw",
                                marginTop: "2vw",
                              }}
                            >
                              {it.desc.map((dc, index) => {
                                return (
                                  <li
                                    key={index}
                                    className={classes["day-text-desc","text-sm mt-1"]}
                                  >
                                    {dc}
                                  </li>
                                );
                              })}
                            </ol>
                            {/* <p className={classes['day-text-desc']}>{it.desc}</p> */}
                          </div>

                        </div>
                      );
                    })}
                  </div>
                </AccordionContent>
              </AccordionItem>
              <AccordionItem
                value="item-2"
                className="text-black bg-gray-100 px-4"
              >
                <AccordionTrigger>
                  <div className="text-black py-2 px-4 text-start w-full">
                    TRIP OVERVIEW
                  </div>
                </AccordionTrigger>
                <AccordionContent>
                  <div className="flex flex-col space-y-6 px-4 py-6 bg-white">
                    <div className="flex flex-col items-center text-center">
                      <SnowflakeIcon className="text-[#F97316] w-12 h-12" />
                      <h2 className="text-lg font-semibold mt-2">Weather</h2>
                      <p className="text-sm mt-1">
                        {quickDetailsViewModel.quickDetails[0].description}
                      </p>
                    </div>
                    <div className="flex flex-col items-center text-center">
                      <CalendarCheckIcon className="text-[#F97316] w-12 h-12" />
                      <h2 className="text-lg font-semibold mt-2">Duration</h2>
                      <p className="text-sm mt-1">
                        {quickDetailsViewModel.quickDetails[1].description}
                      </p>
                    </div>
                    <div className="flex flex-col items-center text-center">
                      <HandIcon className="text-[#F97316] w-12 h-12" />
                      <h2 className="text-lg font-semibold mt-2">Impact</h2>
                      <p className="text-sm mt-1">
                        {quickDetailsViewModel.quickDetails[2].description}
                      </p>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
              <AccordionItem
                value="item-3"
                className="text-black bg-gray-50 px-4"
              >
                <AccordionTrigger>
                  <div className="text-black py-2 px-4 text-start w-full">
                    INCLUSIONS
                  </div>
                </AccordionTrigger>
                <AccordionContent>
                  <div className="bg-white py-4 px-4">
                    {quickDetailsViewModel.inclusions &&
                      quickDetailsViewModel.inclusions.map((inc, index) => {
                        return (
                          <div key={index} className="row flex w-full">
                            <p className="text-sm mt-1">• &nbsp;&nbsp;</p>
                            <p className="text-sm mt-1">{inc}</p>
                          </div>
                        );
                      })}
                  </div>
                </AccordionContent>
              </AccordionItem>
              <AccordionItem
                value="item-4"
                className="text-black bg-gray-100 px-4"
              >
                <AccordionTrigger>
                  <div className="text-black py-2 px-4 text-start w-full">
                    EXCLUSIONS
                  </div>
                </AccordionTrigger>
                <AccordionContent>
                  <div className="bg-white py-4 px-4">
                    {quickDetailsViewModel.exclusions &&
                      quickDetailsViewModel.exclusions.map((inc, index) => {
                        return (
                          <div key={index} className="row flex w-full">
                            <p className="text-sm mt-1">• &nbsp;&nbsp;</p>
                            <p className="text-sm mt-1">{inc}</p>
                          </div>
                        );
                      })}
                  </div>
                </AccordionContent>
              </AccordionItem>
              <AccordionItem
                value="item-5"
                className="text-black bg-gray-50 px-4"
              >
                <AccordionTrigger>
                  <div className="text-black py-2 px-4 text-start w-full">
                    REFUND POLICY
                  </div>
                </AccordionTrigger>
                <AccordionContent>
                  <RefundPolicy />
                  {/* <div className="bg-white">
                    <img
                      alt="Refund Policy"
                      className="h-64 w-full size-fit"
                      src="https://static.wixstatic.com/media/da937f_e9d614329cad4b3789a4db22fe163aa7~mv2.webp"
                    />
                  </div> */}
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>

        {tripStays.length>0 && <TripStays tripStays={tripStays} />}

        <SpotFormMobile
          spotFormViewModel={spotFormViewModel}
          formRef={formRef}
          onFormSubmitted={onFormSubmitted}
          initiatePayment={initiatePayment}
        />

        <div className="bg-white p-4 pt-0 pb-8">
          {/* <p className="text-[5vw] font-bold mb-[30px]">A message from Curator</p> */}
          <div className="mt-1">
            <Avatar className="mx-auto mb-4">
              <AvatarImage
                alt={curatorViewModel.curatorName}
                src={curatorViewModel.curatorImg}
              />
              <AvatarFallback>KP</AvatarFallback>
            </Avatar>
            <h3 className="text-lg font-semibold text-center">
              {curatorViewModel.curatorName}
            </h3>
            <div className="flex justify-center space-x-2">
              <InstagramIcon className="text-red-600 mx-4" />
              {curatorViewModel.curatorInstaId}
            </div>
            <p className="text-sm mt-4 mb-10">{curatorViewModel.curatorInfo}</p>
          </div>
        </div>
        {vibeGallery.length > 0 && <div className="w-full min-h-[45vh] flex flex-col pl-[4vw] mb-[20vw]">
          <p className="text-[6vw] font-bold">The Vibe</p>
          <div style={{ marginLeft: `${vibeGallery.length == 1 ? "13.5vw" : ""}`, }} className="w-full h-[80%] flex flex-row ml-auto mt-[3vh] space-x-[5vw] overflow-x-scroll">
            {
              vibeGallery.map((vibe, index) => {
                return (
                  <>
                    <div className="min-w-[65vw] h-[75vw] rounded-[10px] overflow-hidden">
                      <img className="w-[65vw] h-[75vw] rounded-[10px] object-cover" src={vibe} alt="" />
                    </div>
                  </>
                )
              })
            }
          </div>

        </div>}
        <Toaster />
      </div>
      <div className="fixed bottom-0 h-14 w-full text-lg bg-gray-700 z-10 flex justify-between items-center">
        <h3 className="ms-4 text-lg font-semibold text-white">
          {curatorViewModel.priceLine}
        </h3>
        <Button
          className="bg-orange-600 hover:bg-orange-600 hover:opacity-90 text-white font-bold py-2 px-4 rounded me-4"
          onClick={onBookNowClicked}
        >
          Book Now
        </Button>
      </div>
    </>
  );
};

const CalendarCheckIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
      <line x1="16" x2="16" y1="2" y2="6" />
      <line x1="8" x2="8" y1="2" y2="6" />
      <line x1="3" x2="21" y1="10" y2="10" />
      <path d="m9 16 2 2 4-4" />
    </svg>
  );
};

const HandIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0" />
      <path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2" />
      <path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8" />
      <path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15" />
    </svg>
  );
};

const SnowflakeIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="2" x2="22" y1="12" y2="12" />
      <line x1="12" x2="12" y1="2" y2="22" />
      <path d="m20 16-4-4 4-4" />
      <path d="m4 8 4 4-4 4" />
      <path d="m16 4-4 4-4-4" />
      <path d="m8 20 4-4 4 4" />
    </svg>
  );
};

const InstagramIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
    </svg>
  );
};


const LocationIcon = (props) => {
  return (
    <>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 64 64"
        width="24px"
        height="24px">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <path
            fill="#000000"
            d="M32,2C19.215,2,8.791,12.424,8.791,25.209C8.791,41.666,32,62,32,62s23.209-20.334,23.209-36.791 C55.209,12.424,44.785,2,32,2z M32,33.204c-5.002,0-9.069-4.067-9.069-9.069c0-5.002,4.067-9.069,9.069-9.069 s9.069,4.067,9.069,9.069C41.069,29.137,37.002,33.204,32,33.204z"></path>
        </g>
      </svg>

    </>
  )
};

const CalendarIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 2V5"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 2V5"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 10H21"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 6H19C20.1046 6 21 6.89543 21 8V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V8C3 6.89543 3.89543 6 5 6Z"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 13H16.01"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 13H8.01"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 13H12.01"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 17H8.01"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 17H12.01"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 17H16.01"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

    </>
  )
};

const InfluencerPopup = (props) => {
  return ReactDOM.createPortal(
    <>
      {props.influencerPopup &&
        <div className="w-[100vw] h-[100vh] flex bg-[rgba(0,0,0,0.7)] fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
          onClick={() => { props.setInfluencerPopup(false) }}
        >
          <div style={{ boxShadow: "0px 7px 15px rgba(230, 84, 57, 0.2)" }}
            onClick={(e) => { e.stopPropagation() }}
            className="w-[80vw] h-[max-content] flex flex-col p-[4vw] bg-white rounded-[20px] relative z-[1] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[4vw]">
            <p className="absolute self-end" onClick={() => { props.setInfluencerPopup(false) }}>x</p>

            <img className="w-[25vw] h-[25vw] rounded-full self-center mb-[2vw]" src={props.curatorViewModel.curatorImg} alt="" />
            <p className="text-[5vw] font-bold self-center mb-[1vw]">{props.curatorViewModel.curatorName}</p>
            <div className="w-full h-[60vw] mt-[2vw] mb-[2vw] overflow-y-scroll">
              {props.curatorViewModel.curatorInfo}
              {props.curatorViewModel.curatorInfo}
              {props.curatorViewModel.curatorInfo}
            </div>
          </div>
        </div>
      }
    </>,
    document.getElementById('popup-root')
  )
}
